import Vue from 'vue';

const camelCase = value => {
  if (!value) {
    return '';
  }

  value = value.toString();

  return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
};
export default camelCase;

Vue.filter('camelCase', camelCase);
